import {
  BULK_EDIT_THIRD_PARTY_CUSTOMER_RELATIONSHIPS_FOR_CUSTOMER,
  CREATE_THIRD_PARTY_CUSTOMER_RELATIONSHIP,
  DELETE_THIRD_PARTY_CUSTOMER_RELATIONSHIP,
  EDIT_THIRD_PARTY_CUSTOMER_RELATIONSHIP,
  RECEIVE_THIRD_PARTY_CUSTOMER_RELATIONSHIPS,
  REQUEST_DIGITAL_VENDORS_FOR_CUSTOMER,
  REQUEST_THIRD_PARTY_CUSTOMER_RELATIONSHIP,
  REQUEST_THIRD_PARTY_CUSTOMER_RELATIONSHIPS_FOR_CUSTOMER,
} from '@sophocles/entities/ThirdPartyCustomerRelationship/thirdPartyCustomerRelationshipActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_THIRD_PARTY_CUSTOMER_RELATIONSHIPS: // Read
    case DELETE_THIRD_PARTY_CUSTOMER_RELATIONSHIP: // Delete
    case EDIT_THIRD_PARTY_CUSTOMER_RELATIONSHIP: // Update
    case CREATE_THIRD_PARTY_CUSTOMER_RELATIONSHIP: // Create
    case REQUEST_THIRD_PARTY_CUSTOMER_RELATIONSHIP:
    case REQUEST_DIGITAL_VENDORS_FOR_CUSTOMER:
    case REQUEST_THIRD_PARTY_CUSTOMER_RELATIONSHIPS_FOR_CUSTOMER:
    case BULK_EDIT_THIRD_PARTY_CUSTOMER_RELATIONSHIPS_FOR_CUSTOMER:
    default:
      return state;
  }
}

export function thirdPartyCustomerRelationshipReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_THIRD_PARTY_CUSTOMER_RELATIONSHIP:
    case DELETE_THIRD_PARTY_CUSTOMER_RELATIONSHIP:
    case RECEIVE_THIRD_PARTY_CUSTOMER_RELATIONSHIPS:
    case EDIT_THIRD_PARTY_CUSTOMER_RELATIONSHIP:
    case REQUEST_THIRD_PARTY_CUSTOMER_RELATIONSHIP:
    case REQUEST_DIGITAL_VENDORS_FOR_CUSTOMER:
    case REQUEST_THIRD_PARTY_CUSTOMER_RELATIONSHIPS_FOR_CUSTOMER:
    case BULK_EDIT_THIRD_PARTY_CUSTOMER_RELATIONSHIPS_FOR_CUSTOMER:
      return getState(state, action);
    default:
      return state;
  }
}
